import { render, staticRenderFns } from "./PageTeaching.vue?vue&type=template&id=98de235e&"
import script from "./PageTeaching.vue?vue&type=script&lang=js&"
export * from "./PageTeaching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports